import { useEffect, useState } from 'react';
import './styles.scss';

export const Modal = ({ isOpen, onClose, children, title, className }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      setTimeout(() => setIsVisible(true), 10);
      document.body.style.overflow = 'hidden';
    } else {
      setIsVisible(false);
      setTimeout(() => setShouldRender(false), 300);
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleCloseModal = () => {
    onClose?.();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  if (!shouldRender) return null;

  return (
    <div 
      className={`modal_new-overlay ${isVisible ? 'modal_new-overlay--visible' : ''} ${className}`}
      onClick={handleBackdropClick}
    >
        <div className='modal_new-content'>
          {children}
        </div>
    </div>
  );
};